var ALERT = /** @class */ (function () {
    function ALERT() {
    }
    ALERT.showSimple = function (title, text, icon, abortText, closeOnClickOutside, fn) {
        if (abortText === void 0) { abortText = "OK"; }
        if (closeOnClickOutside === void 0) { closeOnClickOutside = true; }
        sweetAlert({
            title: title,
            text: text,
            icon: icon,
            closeOnClickOutside: closeOnClickOutside,
            buttons: {
                cancel: {
                    text: abortText,
                    value: null,
                    visible: true,
                    className: 'btn btn-warning',
                    closeModal: true,
                }
            }
        }).then(function () { if (fn != undefined)
            fn(); });
    };
    ALERT.showConfirm = function (title, text, fn) {
        sweetAlert({
            title: title,
            text: text,
            icon: "",
            buttons: {
                success: {
                    text: "Ja",
                    value: "ok",
                    visible: true,
                    className: 'btn btn-success',
                    closeModal: true,
                },
                cancel: {
                    text: "Nein",
                    value: null,
                    visible: true,
                    className: 'btn btn-warning',
                    closeModal: true,
                }
            }
        }).then(function (o) {
            if (o)
                fn();
        });
    };
    return ALERT;
}());
export { ALERT };
var Notification = /** @class */ (function () {
    function Notification() {
    }
    Notification.show = function (title, text, style, time) {
        if (time === void 0) { time = 750; }
        $.gritter.add({
            title: title,
            text: text,
            time: time,
            class_name: style
        });
    };
    return Notification;
}());
export { Notification };
